import { Outlet, RouteObject, createBrowserRouter } from 'react-router-dom'
import { AuthUI, Wordmark, Flex, Link } from '@sequencehq/core-components'
import { PostHogPageView } from 'lib/postHog/PostHogPageView'
import { getEnvironment } from 'lib/environment/environment'
import {
  ErrorPage,
  LinkExpiredPage,
  LoginPage,
  NoWorkspacePage,
  SelectWorkspacePage
} from './pages'

const AppContainer = () => {
  const environment = getEnvironment()

  return (
    <AuthUI
      backgroundUrl="/img/login-bg.jpg"
      environment={environment}
      logo={
        <Link to="/login" _hover={{ textDecoration: 'none' }}>
          <Flex position="absolute" top="32px" left="32px" zIndex={10}>
            <Wordmark width="126px" height="32px" />
          </Flex>
        </Link>
      }
    >
      <Outlet />
    </AuthUI>
  )
}

export const loginRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <>
        <AppContainer />
        <PostHogPageView />
      </>
    ),
    children: [
      { path: 'login', element: <LoginPage /> },
      { path: 'callback', element: <SelectWorkspacePage /> },
      { path: 'expired', element: <LinkExpiredPage /> },
      { path: 'select-workspace', element: <SelectWorkspacePage /> },
      { path: 'no-workspace', element: <NoWorkspacePage /> },
      { path: 'error', element: <ErrorPage /> }
    ]
  }
]

export const loginRouter = createBrowserRouter(loginRoutes, {
  basename: '/auth'
})
